module.exports = __webpack_public_path__ + "media/images/proof_links/tiktok-e1e5975799de2ae565921c894806fc0d.svg";